export default [
  {value: 'huadong1', label: '华东1'},
  {value: 'huadong2', label: '华东2'},
  {value: 'us1', label: '美国(硅谷)'},
]
